var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useConfigService } from '@thd-nucleus/experience-context';
import { usePayments } from './use-payments';
import { useModal } from './use-modal';
import { PhaUnenrollT2cConfirmModal, } from '../components/shared/modal/pha-unenroll-t2c-confirm-modal';
import { showConfirmModal } from '../utils/pro-house-account';
import { CardType } from '../constants/payments';
import { PAYMENTS_PAGE_SIZE } from '../constants/general';
export const usePhaUnenrollT2cConfirmModal = ({ selectedCard, }) => {
    const { openModal, hideModal } = useModal();
    const { linesOfCredit, getPaymentCards, t2cCreditCards } = usePayments();
    const isProHouseUIEnabled = !!useConfigService('ENABLE_PHA_UI');
    const selectedCardType = 'locType' in selectedCard && selectedCard.locType
        ? CardType.PRO_HOUSE_ACCOUNT
        : CardType.CREDIT_CARD;
    const fetchCards = () => __awaiter(void 0, void 0, void 0, function* () {
        return {
            updatedLinesOfCredit: (linesOfCredit === null || linesOfCredit === void 0 ? void 0 : linesOfCredit.paymentCards) ||
                (yield getPaymentCards(CardType.PRO_HOUSE_ACCOUNT, true)),
            updatedCreditCards: t2cCreditCards ||
                (yield getPaymentCards(CardType.CREDIT_CARD, true, false, {
                    page: 1,
                    sortBy: 'text2confirm',
                    ascendingOrder: true,
                    pageSize: PAYMENTS_PAGE_SIZE,
                })),
        };
    });
    const openConfirmModal = (confirmModalProps) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isProHouseUIEnabled) {
            return Promise.resolve(true);
        }
        return fetchCards()
            .then(({ updatedLinesOfCredit, updatedCreditCards }) => {
            const shouldShowConfirmModal = !!updatedLinesOfCredit &&
                !!updatedCreditCards &&
                showConfirmModal(selectedCard, updatedLinesOfCredit, updatedCreditCards);
            return shouldShowConfirmModal;
        })
            .catch(() => {
            // should not show confirm modal if fetching fails
            return false;
        })
            .then((shouldShowConfirmModal) => {
            if (!shouldShowConfirmModal) {
                return true;
            }
            return new Promise((resolve) => {
                openModal(PhaUnenrollT2cConfirmModal, {
                    onRejected: () => {
                        resolve(false);
                        hideModal();
                    },
                    onConfirm: () => {
                        resolve(true);
                        hideModal();
                    },
                    card: selectedCard,
                    cardType: selectedCardType,
                    bodyText: confirmModalProps.bodyText,
                    headerText: confirmModalProps.headerText,
                }, { size: 'sm' });
            });
        });
    });
    return [openConfirmModal];
};
